import { createPublicClient, http } from 'viem';
import { bsc } from 'viem/chains';

export const BSC_RPC_URL = 'https://bsc-dataseed.binance.org';

// Reads Chainlink price feeds that live on BNB Chain mainnet, independent
// of whichever chain this explorer instance itself indexes. Uses Binance's
// public RPC explicitly (rather than viem's default) so the endpoint is a
// fixed, known domain that can be allow-listed in the CSP connect-src.
const bscPublicClient = createPublicClient({
  chain: bsc,
  transport: http(BSC_RPC_URL),
});

export default bscPublicClient;
